import axios from 'axios';
import { getBaseUrl } from './helpers';
import { refreshToken } from './auth';

// API Endpoints
const GET_INCIDENTS_ENDPOINT = `/alerts/api/incidents/`;
const GET_ALERTS_ENDPOINT = `/alerts/api/alerts`;
const ALERTS_FOLLOWERS_ENDPOINT = `/alerts/api/followers/`;

export const getRecentIncidents = async (env, identifier) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    const refreshed = await refreshToken(env);

    if (!refreshed) {
      return null;
    }

    authToken = refreshed.token;
  }

  try {
    const response = await axios
    .get(`${BASE_URL}${GET_INCIDENTS_ENDPOINT}${identifier}/events/recent/`, {
      headers: {
        Authorization: `JWT ${authToken}`,
        'Content-Type': 'application/json',
      },
      building_identifier: identifier,
    })

    return response.data;

  } catch (error) {
    if (error.response.status === 401) {
        const refreshed = await refreshToken(env);

        if (!refreshed) {
          return null;
        }

        return getRecentIncidents(env, identifier);
      }
      return Promise.reject(error.response?.data?.errors?.[0]?.message);
  }
};

export const getIncidentOverview = async (env, building) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    const refreshed = await refreshToken(env);

    if (!refreshed) {
      return null;
    }

    authToken = refreshed.token;
  }

  try {
    const response = await axios
    .get(`${BASE_URL}${GET_INCIDENTS_ENDPOINT}${building}/events/overview/`, {
      headers: {
        Authorization: `JWT ${authToken}`,
        'Content-Type': 'application/json',
      },
    })

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
        const refreshed = await refreshToken(env);

        if (!refreshed) {
          return null;
        }

        return getIncidentOverview(env, building);
      }
      return Promise.reject(error.response?.data?.errors?.[0]?.message);
  }
};

export const getIncidents = async (env, building, isResolved) => { // Not used
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    const refreshed = await refreshToken(env);

    if (!refreshed) {
      return null;
    }

    authToken = refreshed.token;
  }

  try {
    const response = await axios.get(
      `${BASE_URL}${GET_INCIDENTS_ENDPOINT}${building}/?page_size=10&page=1&is_resolved=${isResolved}`,
      {
        headers: {
          Authorization: `JWT ${authToken}`,
          'Content-Type': 'application/json',
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      const refreshed = await refreshToken(env);

      if (!refreshed) {
        return null;
      }

      return getIncidents(env, building, isResolved);
    }

    return Promise.reject(error.response?.data?.errors?.[0]?.message);
  }
};

export const getIncidentDetail = async (env, building, incidentId) => { // Not Used
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    const refreshed = await refreshToken(env);

    if (!refreshed) {
      return null;
    }

    authToken = refreshed.token;
  }

  try {
    const response = await axios.get(
      `${BASE_URL}${GET_INCIDENTS_ENDPOINT}${building}/${incidentId}/`,
      {
        headers: {
          Authorization: `JWT ${authToken}`,
          'Content-Type': 'application/json',
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      const refreshed = await refreshToken(env);

      if (!refreshed) {
        return null;
      }

      return getIncidentDetail(env, building, incidentId);
    }

    return Promise.reject(error.response?.data?.errors?.[0]?.message);
  }
};

export const getEventDetail = async (env, building, incidentId, eventId) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    const refreshed = await refreshToken(env);

    if (!refreshed) {
      return null;
    }

    authToken = refreshed.token;
  }

  try {
    const response = await axios.get(
      `${BASE_URL}${GET_INCIDENTS_ENDPOINT}${building}/events/${incidentId}/${eventId}/`,
      {
        headers: {
          Authorization: `JWT ${authToken}`,
          'Content-Type': 'application/json',
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      const refreshed = await refreshToken(env);

      if (!refreshed) {
        return null;
      }

      return getEventDetail(env, building, incidentId, eventId);
    }

    if (error.response?.status === 404) {
      return Promise.reject(error.response.status);
    }

    return Promise.reject(error.response?.data?.errors?.[0]?.message);
  }
};

export const getIncidentData = async (env, apiLocation) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    const refreshed = await refreshToken(env);

    if (!refreshed) {
      return null;
    }

    authToken = refreshed.token;
  }

  try {
    const response = await axios.get(
      `${BASE_URL}${apiLocation}`,
      {
        headers: {
          Authorization: `JWT ${authToken}`,
          'Content-Type': 'application/json',
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      const refreshed = await refreshToken(env);

      if (!refreshed) {
        return null;
      }

      return getIncidentData(env, apiLocation);
    }

    return Promise.reject(error.response?.data?.errors?.[0]?.message);
  }
};

export const getCustomIncidentData = async (env, building, dataPoints, startTime, endTime) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    const refreshed = await refreshToken(env);

    if (!refreshed) {
      return null;
    }

    authToken = refreshed.token;
  }

  try {
    const response = await axios.get(
      `${BASE_URL}/building/api/tracking/${building}/alert-data/?data_points=${dataPoints}&start_datetime=${startTime}&end_datetime=${endTime}`,
      {
        headers: {
          Authorization: `JWT ${authToken}`,
          'Content-Type': 'application/json',
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      const refreshed = await refreshToken(env);

      if (!refreshed) {
        return null;
      }

      return getCustomIncidentData(env, building, dataPoints, startTime, endTime);
    }

    return Promise.reject(error.response?.data?.errors?.[0]?.message);
  }
};

export const postComment = async (env, apiLocation, comment) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    const refreshed = await refreshToken(env);

    if (!refreshed) {
      return null;
    }

    authToken = refreshed.token;
  }

  try {
    await axios.post(
      `${BASE_URL}${apiLocation}`,
      {
        comment,
      },
      {
        headers: {
          Authorization: `JWT ${authToken}`,
          'Content-Type': 'application/json',
        },
      }
    );

    return true;
  } catch (error) {
    if (error.response?.status === 401) {
      const refreshed = await refreshToken(env);

      if (!refreshed) {
        return null;
      }

      return postComment(env, apiLocation, comment);
    }

    return Promise.reject(error.response?.data?.errors?.[0]?.message);
  }
};

export const getAlertsCount = async (env) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    const refreshed = await refreshToken(env);

    if (!refreshed) {
      return null;
    }

    authToken = refreshed.token;
  }

  try {
    const response = await axios.get(
      `${BASE_URL}${GET_ALERTS_ENDPOINT}/alert-count/`,
      {
        headers: {
          Authorization: `JWT ${authToken}`,
          'Content-Type': 'application/json',
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      const refreshed = await refreshToken(env);

      if (!refreshed) {
        return null;
      }

      return getAlertsCount(env);
    }

    return Promise.reject(error.response?.data?.errors?.[0]?.message);
  }
};

export const snoozeAlert = async (env, alert_id, snooze_time = 0) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    const refreshed = await refreshToken(env);

    if (!refreshed) {
      return null;
    }

    authToken = refreshed.token;
  }

  try {
    await axios.put(
      `${BASE_URL}${ALERTS_FOLLOWERS_ENDPOINT}${alert_id}/snooze/`,
      {
        alert_uid_hash: alert_id,
        snooze_hours: snooze_time,
      },
      {
        headers: {
          Authorization: `JWT ${authToken}`,
          'Content-Type': 'application/json',
        },
      }
    );

    return true;
  } catch (error) {
    if (error.response?.status === 401) {
      const refreshed = await refreshToken(env);

      if (!refreshed) {
        return null;
      }

      return snoozeAlert(env, alert_id, snooze_time);
    }

    return Promise.reject(error.response?.data?.errors?.[0]?.message);
  }
};

export const getAlertPreferencesList = async (env, building) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    const refreshed = await refreshToken(env);

    if (!refreshed) {
      return null;
    }

    authToken = refreshed.token;
  }

  try {
    const response = await axios.get(
      `${BASE_URL}${ALERTS_FOLLOWERS_ENDPOINT}${building}/preferences/`,
      {
        headers: {
          Authorization: `JWT ${authToken}`,
          'Content-Type': 'application/json',
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      const refreshed = await refreshToken(env);

      if (!refreshed) {
        return null;
      }

      return getAlertPreferencesList(env, building);
    }

    return Promise.reject(error.response?.data?.errors?.[0]?.message);
  }
};

export const updateSpecificAlertPreferences = async (env, building, uidHash, subscription, type) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    const refreshed = await refreshToken(env);

    if (!refreshed) {
      return null;
    }

    authToken = refreshed.token;
  }

  try {
    await axios.put(
      `${BASE_URL}${ALERTS_FOLLOWERS_ENDPOINT}${building}/preferences/${uidHash}/`,
      {
        subscribe_to: subscription,
        subscription_type: type,
      },
      {
        headers: {
          Authorization: `JWT ${authToken}`,
          'Content-Type': 'application/json',
        },
      }
    );

    return true;
  } catch (error) {
    if (error.response?.status === 401) {
      const refreshed = await refreshToken(env);

      if (!refreshed) {
        return null;
      }

      return updateSpecificAlertPreferences(env, building, uidHash, subscription, type);
    }

    return Promise.reject(error.response?.data?.errors?.[0]?.message);
  }
};

export const updateAllAlertPreferences = async (env, building, subscription, type) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    const refreshed = await refreshToken(env);

    if (!refreshed) {
      return null;
    }

    authToken = refreshed.token;
  }

  try {
    await axios.put(
      `${BASE_URL}${ALERTS_FOLLOWERS_ENDPOINT}${building}/preferences/bulk-change/`,
      {
        subscribe_to: subscription,
        subscription_type: type,
      },
      {
        headers: {
          Authorization: `JWT ${authToken}`,
          'Content-Type': 'application/json',
        },
      }
    );

    return true;
  } catch (error) {
    if (error.response?.status === 401) {
      const refreshed = await refreshToken(env);

      if (!refreshed) {
        return null;
      }

      return updateAllAlertPreferences(env, building, subscription, type);
    }

    return Promise.reject(error.response?.data?.errors?.[0]?.message);
  }
};

export const getAlertResolutionsList = async (env, isUserCreated) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    const refreshed = await refreshToken(env);

    if (!refreshed) {
      return null;
    }

    authToken = refreshed.token;
  }

  try {
    const response = await axios.get(
      `${BASE_URL}${GET_INCIDENTS_ENDPOINT}resolutions/?is_user_created=${isUserCreated}`,
      {
        headers: {
          Authorization: `JWT ${authToken}`,
          'Content-Type': 'application/json',
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      const refreshed = await refreshToken(env);

      if (!refreshed) {
        return null;
      }

      return getAlertResolutionsList(env, isUserCreated);
    }

    return Promise.reject(error.response?.data?.errors?.[0]?.message);
  }
};

// Includes adding, updating and deleting alert resolutions
export const updateAlertResolutions = async (env, building, incidentUidHash, uidHash, resolutions) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    const refreshed = await refreshToken(env);

    if (!refreshed) {
      return null;
    }

    authToken = refreshed.token;
  }

  try {
    await axios.patch(
      `${BASE_URL}${GET_INCIDENTS_ENDPOINT}${building}/events/${incidentUidHash}/${uidHash}/`,
      { resolutions },
      {
        headers: {
          Authorization: `JWT ${authToken}`,
          'Content-Type': 'application/json',
        },
      }
    );

    return true;
  } catch (error) {
    if (error.response?.status === 401) {
      const refreshed = await refreshToken(env);

      if (!refreshed) {
        return null;
      }

      return updateAlertResolutions(env, building, incidentUidHash, uidHash, resolutions);
    }

    return Promise.reject(error.response?.data?.errors?.[0]?.message);
  }
};

export const getEventsList = async (env, building, filters = {}) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    const refreshed = await refreshToken(env);

    if (!refreshed) {
      return null;
    }

    authToken = refreshed.token;
  }

  let filtersUrl = '?page_size=12';

  // Appending the filters to the URL if there are any
  if (Object.keys(filters).length > 0) {
    Object.keys(filters).forEach((filterName) => {
      filtersUrl += `&${filterName}=${filters[filterName]}`;
    });
  }

  try {
    const response = await axios.get(
      `${BASE_URL}${GET_INCIDENTS_ENDPOINT}${building}/events/${filtersUrl}`,
      {
        headers: {
          Authorization: `JWT ${authToken}`,
          'Content-Type': 'application/json',
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      const refreshed = await refreshToken(env);

      if (!refreshed) {
        return null;
      }

      return getEventsList(env, building, filters);
    }

    return Promise.reject(error.response?.data?.errors?.[0]?.message);
  }
};

export const getEventFilterOptions = async (env, building) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    const refreshed = await refreshToken(env);

    if (!refreshed) {
      return null;
    }

    authToken = refreshed.token;
  }

  try {
    const response = await axios.get(
      `${BASE_URL}${GET_INCIDENTS_ENDPOINT}${building}/events/filter-options/`,
      {
        headers: {
          Authorization: `JWT ${authToken}`,
          'Content-Type': 'application/json',
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      const refreshed = await refreshToken(env);

      if (!refreshed) {
        return null;
      }

      return getEventFilterOptions(env, building);
    }

    return Promise.reject(error.response?.data?.errors?.[0]?.message);
  }
};
